import React from 'react';

import { DefinitionHeader } from 'components/common/fields/DefinitionHeader';

export const PersonLabels = ({ labels }) => (labels) ? (
    <div className="pmb-block p-b-0">
        <DefinitionHeader translate="person.tags" iconType="tags" />
        <div className="panel-view">
            <span className='text-pre-space'>{ labels }</span>
        </div>
    </div>
) : null;
